import { connectStateResults } from 'react-instantsearch-dom'
import { useTranslation } from 'next-i18next'

interface CustomStatsProps {
  searchResults?: {
    nbHits: number
    hitsPerPage: number
  }
  searchState: {
    page?: number
  }
  searchName?: string
}

const CustomStats = ({
  searchResults,
  searchState,
  searchName = '',
}: CustomStatsProps) => {
  const { t: translate } = useTranslation('common')

  if (!searchResults) return null

  const { nbHits, hitsPerPage } = searchResults
  const currentPage = searchState.page || 1
  const end = Math.min(currentPage * hitsPerPage, nbHits)

  return (
    <div className="capitalize">
      {`${translate(
        'text-showing',
      )} ${end} / ${nbHits.toLocaleString()} ${searchName} ${translate(
        'text-products',
      )}`}
    </div>
  )
}

const ConnectedStats = connectStateResults(CustomStats)

export function SearchStats({ searchName }: { searchName: string }) {
  return <ConnectedStats searchName={searchName} />
}
